import OperationIcon from './OperationIcon';

export default OperationIcon;
